import { HistoryItemContext } from "./index.js";

export const KeyValEntryType_SCORE = "score"
export type KeyValType = string | typeof KeyValEntryType_SCORE;

export type AchieveMent = {
  value: number;
  skillId: string;
  message: string;
};
export type ScoreData = {
  scoreName: string;
  score: number
  achieveMents: AchieveMent[];
}
export type KeyValEntry<V = unknown | ScoreData, ID = string, D = string> = {
  _id: ID,
  type: KeyValType;
  key: string;
  value: V;
  created: D,
  updated: D,
  context: HistoryItemContext;
}

export const isKeyValEntryScoreData = (entry: KeyValEntry): entry is KeyValEntry<ScoreData> => {
  return (entry as KeyValEntry<ScoreData>).type === KeyValEntryType_SCORE;
}
export const isKeyValEntryUnkownData = (entry: KeyValEntry): entry is KeyValEntry<unknown> => {
  return entry.type !== KeyValEntryType_SCORE;
}